import { createBaseThemeVariation } from './base';
export const EspiraTheme = createBaseThemeVariation({
    name: 'espira',
    brandColor: 'hsla(357, 60%, 40%, 1)',
});
